import { memo } from "react";

import Banner from "./components/Banner";
import BrandingSection from "./components/BrandingSection";
import ExploreProductsSection from "./components/ExploreProductsSection";
import FileStorageSection from "./components/FileStorageSection";
import InboxSection from "./components/InboxSection";
import InstantDeliverySection from "./components/InstantDeliverySection";
import ManageTeamSection from "./components/ManageTeamSection";
import SecuritySection from "./components/SecuritySection";
import SocialCollabsSection from "./components/SocialCollabsSection";
import UnlockAllSection from "./components/UnlockAllSection";
import useScrollToSection from "./components/hookx/useScrollToSection";

import styles from "./styles.module.scss";

/**
 * Main component of the Features page.
 */
const Features = memo(() => {
  useScrollToSection();
  
  return (
    <div className={styles.featurePageWrapper}>
      <Banner />
      <InstantDeliverySection />
      <FileStorageSection />
      <SecuritySection />
      <BrandingSection />
      <SocialCollabsSection />
      <InboxSection />
      <ManageTeamSection />
      <ExploreProductsSection />
      <UnlockAllSection />
    </div>
  );
});

export default Features;
